export const DEMOGRAPHICSENTITYID = 9;

//Toast Messages
export const ERROR_TOAST = "Please review errors below";
export const SUCCESS_TOAST = "success";
export const RED_TOAST = "danger";
